import { ClarityProxy } from 'util/clarity';

export const reportSentryEventToClarity = event => {
  if (!event) return event;
  try {
    ClarityProxy.event('Sentry Error');
    if (event.event_id) {
      ClarityProxy.setTag('sentry_error_id', event.event_id);
    }
    ClarityProxy.upgrade('sentry_error');
  } catch {
    // ClarityProxy already swallows errors; this is a final safety net so
    // Sentry's beforeSend pipeline is never interrupted.
  }
  return event;
};
